import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import { send } from './requests';

/**
 * @param {{email: string, password: string}} data
 */
function login(data) {
  return new Promise((resolve, reject) => {
    send('login', { data, method: 'POST' })
      .then((result) => {
        const response = result.data;
        if (!response.success) return;
        const { token, name } = response.data;

        Cookies.set('token', token);
        Cookies.set('name', name);
        toast.success('Welcome back');
        resolve({ token, name });
      })
      .catch((error) => {
        toast.error('Email or password is incorrect !!');
        console.error(error);
        reject(error);
      });
  });
}

/**
 * @returns {Promise<boolean>}
 */
function checkLogin() {
  return new Promise((resolve) => {
    const token = Cookies.get('token');
    if (!token) return resolve(false);
    send('user')
      .then((result) => {
        const response = result.data;
        resolve(response && response.success && response.data.id);
      })
      .catch(() => resolve(false));
  });
}

function isLogin() {
  return !!Cookies.get('token');
}

async function getUser() {
  const response = await send('user');
  const { data, success } = response.data;
  if (!success) return {};
  return data;
}

export { login, checkLogin, isLogin, getUser };
